import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gax-page-section-header-title',
  templateUrl: './page-section-header-title.component.html',
  styleUrl: './page-section-header-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PageSectionHeaderTitleComponent {}
